import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { UserDTO } from 'src/app/shared/dtos/UserDTO';
import { tap, catchError } from 'rxjs/operators';
import { TokenStorageService } from './token-storage.service';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Farm } from 'src/app/shared/dtos/Farm';
import { MessageService } from './message.service';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private AUTH_API = environment.serverUrl + 'auth/';
  private USER_API = environment.serverUrl + 'user/'
  userDTO: UserDTO;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  //private userLogged = new BehaviorSubject<UserDTO>(null);

  //userLogged$ = this.userLogged.asObservable();
  constructor(
    private http: HttpClient, 
    private tokenService: TokenStorageService,
    private messageService: MessageService) { }

  login(credentials): Observable<any> {
    return this.http.post(this.AUTH_API + 'signin', {
      username: credentials.username,
      password: credentials.password
    }, httpOptions);
  }

  register(user: UserDTO): Observable<any> {
    return this.http.post(this.AUTH_API + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password,
      name: user.name,
      surname: user.surname,
      phoneNumber: user.phoneNumber
    }, httpOptions);
  }

  getCurrentUser(): Observable<UserDTO> {
    return this.http.get<UserDTO>(this.AUTH_API)
      .pipe(
        tap(_ => console.log('fetch current user')),
        catchError(this.handleError<UserDTO>('getCurrentUser'))
      );
  }

  updateUser (user: UserDTO): Observable<any> {
    return this.http.put(this.USER_API, user, this.httpOptions).pipe(
      tap(_ => this.log(`updated user id=${user.id}`)),
      catchError(this.handleError<UserDTO>('updateUser'))
    );
  }

  isLoggedIn(): boolean {
    return (this.tokenService.getToken() === null ? false : true);
  }

 

/**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.error(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

    /** Log a HeroService message with the MessageService */
    private log(message: string) {
      this.messageService.add(`UserService: ${message}`);
    }

}
